import Mutations from '../../odata/mutations';

export default { ...new Mutations('driver'), ...new Mutations('drivers') };
